<app-view-title Title=""></app-view-title>
<view-content [fullscreen]="true" [centered]="true">
  @if(showVerifySpinner) {
  <div class="loading-overlay">
    <mat-progress-spinner diameter="70" mode="determinate" [value]="verifyProgressValue"></mat-progress-spinner>
    <p>{{'Itellitrailer.UnconfirmedBooking.txtVerifyingPayment' | translate: 'Verifying payment...'}}</p>
  </div>
  }
  @if(paymentFailed) {
  <ng-container> 
    <app-information-screen [centered]="true" title="{{ 'Intellitrailer.Booking.PaymentFailed.PaymentNotCompletedTitle' | translate : 'Payment not completed' }}"
                            primaryContent="{{ 'Intellitrailer.Booking.PaymentFailed.PaymentCancelled' | translate : 'The payment was cancelled. Please try again.' }}">
    </app-information-screen>
  </ng-container>
  }
  @if(!returnAction && !paymentFailed) {
  <ng-container>
    @if(redirecting) {
    <ng-container>
      <app-loading-screen [centered]="true" title="{{ 'Intellitrailer.Booking.Payment.PreparingPayment' | translate : 'Preparing payment' }}" description="{{ 'Intellitrailer.Booking.Payment.msgPreparingPayment' | translate : 'You are being redirected to payment' }}"></app-loading-screen>
    </ng-container>
    }
    @if(!redirecting && amount) {
    <ng-container>
      <app-information-screen [centered]="true" title="{{ 'Intellitrailer.Booking.PaymentFailed.InsufficientFunding' | translate : 'This booking is not fully paid' }}"
                              primaryContent="{{ 'Intellitrailer.Booking.PaymentFailed.UnsettledAmount' | translate : 'An additional {0} needs to paid.' : [ amount ] }}"
                              secondaryContent="{{ 'Intellitrailer.Booking.PaymentFailed.UnsettledDescription' | translate : 'Either the booking has changed since it was booked or the credit card you added could not be charged.' }}">
      </app-information-screen>
    </ng-container>
    }
  </ng-container>
  }
</view-content>

<view-actions>
  @if(paymentFailed) {
  <button mat-raised-button (click)="retry()">{{ 'Intellitrailer.Booking.Paymen.cmdRetry' | translate : 'Retry' }}</button>
  }
  @if(!returnAction && !redirecting && !paymentFailed && !showVerifySpinner) {
  <button mat-raised-button (click)="redirect()">{{ 'Intellitrailer.Booking.Paymen.cmdPay' | translate : 'Pay' }}</button>
  }
</view-actions>

